import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TheWoodsCardData } from '../../../../../../../../models/print-cards/the-woods-card-data';
import { RenderContextComponent } from '../../../../../../../../models/base/render-context-component';
import { TheWoodsPotencyMeterViewModel } from './the-woods-potency-meter-view-model';

@Component({
  selector: 'app-the-woods-potency-meter',
  templateUrl: './the-woods-potency-meter.component.html',
  styleUrl: './the-woods-potency-meter.component.scss',
  providers: [TheWoodsPotencyMeterViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TheWoodsPotencyMeterComponent extends RenderContextComponent implements OnChanges {
  constructor(public viewModel: TheWoodsPotencyMeterViewModel) {
    super();
  }

  @Input() cardData: TheWoodsCardData;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cardData) {
      this.viewModel.connectToCardData(this.cardData);
    }
  }

  setupViews() {}
  setupBindings() {}
}
